import { Component, Input } from '@angular/core';

@Component({
  selector: 'pub-date-widget',
  templateUrl: './date-widget.component.html',
  styleUrls: ['./date-widget.component.scss'],
})
export class DateWidgetComponent {
  @Input() date!: string;
}
